import { render, staticRenderFns } from "./NDZNTaskStatus.vue?vue&type=template&id=508f4d7c&"
import script from "./NDZNTaskStatus.vue?vue&type=script&lang=js&"
export * from "./NDZNTaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports